import HealthChecksContainer from './HealthChecksContainer';

export default HealthChecksContainer;
